import { NgModule }       from '@angular/core';
import {CommonModule} from '@angular/common'
import { FormsModule } from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';

import { AuditComponent }    from './audit.component';
import { AuditRoutingModule } from './audit-routing.module';
import {AuditFilterComponent} from "./audit-filter/audit-filter.component";
import {AuditListComponent} from "./audit-list/audit-list.component";
import {DatePickerModule} from "../../core/datepicker/datepicker.module";

@NgModule({
    declarations: [
        AuditComponent,
        AuditFilterComponent,
        AuditListComponent
    ],
    imports: [
        AuditRoutingModule,
        CommonModule,
        DatePickerModule,
        FormsModule,
        TranslateModule]
})
export class AuditModule {}


// WEBPACK FOOTER //
// ./public/upgrade/feature/audit/audit.module.ts